<script setup lang="ts">
import { computed } from 'vue';
import type { Corner } from '../live-scanner';

const props = defineProps<{
  /** 4 угла в координатах исходного видео (vw × vh) */
  corners: Corner[] | null;
  /** Размер видео — нужен для viewBox */
  videoWidth: number;
  videoHeight: number;
  /** В состоянии «лист поймал, считаем стабильность» — рамка зелёная */
  capturing?: boolean;
}>();

const cornersString = computed(() => {
  if (!props.corners || props.corners.length !== 4) return '';
  return props.corners.map((p) => `${p.x},${p.y}`).join(' ');
});

const viewBox = computed(() => {
  return `0 0 ${props.videoWidth || 1280} ${props.videoHeight || 720}`;
});
</script>

<template>
  <svg
    class="live-overlay"
    :viewBox="viewBox"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <!-- Затемнение вне квада: рисуем большой path с even-odd для «вырезания» -->
    <defs>
      <mask id="paper-mask">
        <rect x="0" y="0" :width="videoWidth || 1280" :height="videoHeight || 720" fill="white" />
        <polygon v-if="corners" :points="cornersString" fill="black" />
      </mask>
    </defs>
    <rect
      v-if="corners"
      x="0"
      y="0"
      :width="videoWidth || 1280"
      :height="videoHeight || 720"
      fill="rgba(0,0,0,0.35)"
      mask="url(#paper-mask)"
    />

    <!-- Сам quad: лёгкая жёлтая заливка + золотой контур + glow -->
    <polygon
      v-if="corners"
      :points="cornersString"
      :class="['quad', { capturing }]"
    />
  </svg>
</template>

<style scoped>
.live-overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.quad {
  fill: rgba(255, 204, 0, 0.12);
  stroke: #ffcc00;
  stroke-width: 4;
  stroke-linejoin: round;
  stroke-linecap: round;
  /* Сглаживание движения рамки (cubic-bezier — natural feel) */
  transition: all 120ms cubic-bezier(0.4, 0, 0.2, 1);
  /* Золотое свечение */
  filter: drop-shadow(0 0 8px rgba(255, 204, 0, 0.55));
}

.quad.capturing {
  /* Когда стабильно — рамка зелёная (как у Adobe в момент захвата) */
  fill: rgba(16, 185, 129, 0.18);
  stroke: #10b981;
  filter: drop-shadow(0 0 12px rgba(16, 185, 129, 0.75));
}
</style>
